export default "__VITE_ASSET__75221697__"